<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag
  [windowMovable]="false" [windowResizable]="false" [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">1物N価取扱期間一覧表</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">媒体</label>
            <div class="list-input-content">
              <select class="combo-box-normal" id="cmb_MediumType" #cmb_MediumType
                [(ngModel)]="kymw1321Model.selectedMediumType" forcedEnabledMode="true" [tabindex]="0"
                (change)="eventMediumType_CHANGEHandler()">
                <ng-template ngFor let-item [ngForOf]="kymw1321Model.dispMediumTypeList">
                  <option value="{{item.MediumType}}">{{item.MediumTypeName}}</option>
                </ng-template>
              </select>
            </div>

            <label class="list-input-title">束ね企画名</label>
            <div class="list-input-content">
              <select id="cmb_BundleCatalogGuideStandardName" #cmb_BundleCatalogGuideStandardName
                forcedEnabledMode="true" [tabindex]="0" [(ngModel)]="kymw1321Model.selectBundleCatalogRound"
                [disabled]="isDisabledBundleCatalog" (change)="eventBundleCatalogGuideStandardName_CHANGEHandler()">
                <ng-template ngFor let-item [ngForOf]="kymw1321Model.dispBundleCatalogRoundInfoList">
                  <option value="{{item.BundleCatalogRoundId}}">{{item.BundleCatalogRoundName}}</option>
                </ng-template>
              </select>
              <input type="text" class="order-code" readonly [(ngModel)]="kymw1321Model.startBundleOrderCode">
              <label>～</label>
              <input type="text" class="order-code" readonly [(ngModel)]="kymw1321Model.endBundleOrderCode">
            </div>
          </div>

          <div class="element-row">
            <div class="column-list">
              <label class="list-input-title">受注コード</label>
              <input type="text" id="txt_StartOrderCode" #txt_StartOrderCode class="list-input-content order-code" forcedEnabledMode="true"
                [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7"
                [(ngModel)]="kymw1321Model.startOrderCode">
            </div>
            <div class="column-list">
              <label class="list-input-title">Ｐコード</label>
              <input type="text" id="txt_PCode" #txt_PCode class="list-input-content pcode" forcedEnabledMode="true"
                [tabindex]="0" plessInputTextSub [restrict]="'[P0-9]'" [maxlength]="8"
                [(ngModel)]="kymw1321Model.pCode">
            </div>
          </div>

          <div class="element-row">
            <div class="column-list">
              <label class="list-input-title">アイテムコード</label>
              <input type="text" id="txt_ItemCode" class="list-input-content" #txt_ItemCode forcedEnabledMode="true"
                plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7" [tabindex]="0"
                [(ngModel)]="kymw1321Model.itemCode">
            </div>
            <div class="column-list">
              <label class="list-input-title">注文コード</label>
              <input type="text" class="list-input-content" id="txt_OrderNum" plessInputTextSub [restrict]="'[0-9]'"
                #txt_OrderNum forcedEnabledMode="true" [tabindex]="0" [(ngModel)]="kymw1321Model.orderNum"
                [maxlength]="6">
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Output" class="btn-primary" forcedEnabledMode="true" [tabindex]="0"
            (click)="eventOutput_CLICKHandler()">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button id="btn_Close" forcedEnabledMode="true" [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>